/**
 * Coups de pouce — Attendu 649 « Déterminer un volume (compter les cubes,
 * y compris les cachés) ».
 *
 * MÊME méthode que 648 (décision utilisateur, 2026-07-31) : la fiche
 * « Compte étage par étage » est IMPORTÉE de ./648 — une seule source de
 * vérité, toute retouche future profite aux deux gens. Sa ligne 2 (« n'oublie
 * pas les cubes cachés ») est précisément l'étiquette de cet attendu.
 */

import cp648 from './648';

const FICHE_COMPTAGE = cp648.comparer_volumes_qcm_unique;

const CP_649 = {
    determiner_volume_qcm_unique: FICHE_COMPTAGE,
    determiner_volume_texte: FICHE_COMPTAGE,
    determiner_volume_texte_trou_saisie: FICHE_COMPTAGE,
    determiner_volume_relier: FICHE_COMPTAGE,
};

export default CP_649;
